import { useRef, useState } from 'react'

import PropTypes from 'prop-types'

import * as Sc from './Tooltip.style'
import useOnClickOutSide from 'hooks/useOnClickOutSide'


const Tooltip = ({ text, children }) => {
  const [showInfo, setShowInfo] = useState(false)
  const ref = useRef(null)
  useOnClickOutSide(ref, () => setShowInfo(false))

  return (
    <Sc.Container>
      <Sc.Icon data-testid='tooltip' onClick={() => setShowInfo(true)}>
        {children}
      </Sc.Icon>
      {showInfo && (
        <Sc.TextInfo ref={ref}>
          <p>{text}</p>
        </Sc.TextInfo>
      )}
    </Sc.Container>
  )
}

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  text: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
}

export default Tooltip
